 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"404":"404","CourseLibraryEdit~CourseLibrarySection~CourseShop":"CourseLibraryEdit~CourseLibrarySection~CourseShop","CourseShop":"CourseShop","CourseLibrary~CourseResources":"CourseLibrary~CourseResources","CourseLibrary":"CourseLibrary","CourseResources":"CourseResources","CourseResourcesEdit":"CourseResourcesEdit","Dashboard":"Dashboard","EducationalAdd":"EducationalAdd","EducationalBatchAdd":"EducationalBatchAdd","EducationalEdit":"EducationalEdit","MySalesRecord":"MySalesRecord","MySalesRecordAdd":"MySalesRecordAdd","OfflineRecordReview":"OfflineRecordReview","ProductManage":"ProductManage","Redirect":"Redirect","CourseLibrarySection":"CourseLibrarySection","ProductManageAdd":"ProductManageAdd","CourseLibraryAdd":"CourseLibraryAdd","CourseLibraryEdit":"CourseLibraryEdit","CourseResourcesAdd":"CourseResourcesAdd","CourseProgress":"CourseProgress","CollegeRealName":"CollegeRealName"}[chunkId]||chunkId) + "." + {"404":"eecc7a71","CourseLibraryEdit~CourseLibrarySection~CourseShop":"6d640374","CourseShop":"0494ac1e","CourseLibrary~CourseResources":"ab217b34","CourseLibrary":"6ac53741","CourseResources":"aa2a1ecc","CourseResourcesEdit":"8af86972","Dashboard":"bca8ec05","EducationalAdd":"7a13186b","EducationalBatchAdd":"156cb0fe","EducationalEdit":"307b19ab","MySalesRecord":"7305ecda","MySalesRecordAdd":"05cba305","OfflineRecordReview":"a48793cf","ProductManage":"fb1a8341","Redirect":"9e08606d","chunk-037f4b61":"26fb37ee","chunk-04be5594":"732b579f","chunk-07b406d3":"f5485beb","chunk-0b6a1d54":"af13fd37","chunk-166839b5":"e8b9d29d","chunk-1ac974be":"712b0aee","chunk-1f24ceb0":"ab9d7d82","CourseLibrarySection":"446b7097","chunk-1bb13728":"4791738f","chunk-5d3ccfe1":"eb895321","chunk-7e84dcd0":"2226af0a","chunk-1f75a0b4":"76904287","chunk-20062d88":"697bee14","chunk-2087d242":"34f3f480","chunk-218d0c12":"c1ccb240","chunk-22ce03a8":"7d4ed71c","chunk-2431d57f":"e1f1fe97","chunk-2592f322":"07563cb6","chunk-29cfdbb3":"3cbe69aa","chunk-2df5ae5a":"92b1913e","chunk-2e24c3ec":"10bc787f","ProductManageAdd":"fabc875e","CourseLibraryAdd":"f25712d9","CourseLibraryEdit":"ba3e8ceb","CourseResourcesAdd":"65400bce","chunk-b714e690":"2a3b024d","chunk-3eed9f9a":"aba30d4c","chunk-4abe596c":"ce439342","chunk-5376cd13":"1e1f7aa4","chunk-59677937":"7f7832ba","chunk-c9ae9d90":"fc5c562a","chunk-2f9e4792":"9f21fec6","chunk-314c2070":"92233bdb","chunk-34ff69a4":"8215ce87","chunk-365e9475":"b9ed7d8d","chunk-36ff58fd":"d658db0b","chunk-37fb59a2":"1655c568","chunk-3ccf676e":"dd9cd419","chunk-3f74100c":"5d18dc37","chunk-412d0cc6":"9759c2aa","chunk-41fa7260":"2e00af6a","chunk-424d0da2":"d4bb7d60","chunk-4a308614":"34252bba","chunk-4bf58560":"e76c25b4","chunk-563b9f0c":"1a520ba4","chunk-58222bce":"f0291089","chunk-5ad459ce":"b14a34cf","chunk-5c6bb2fc":"d7396369","chunk-5c788fd0":"e08628aa","chunk-63721bda":"b0f53b68","chunk-63dead69":"844ab9d9","chunk-63ead194":"feb64544","chunk-6a411276":"bcf903e8","CourseProgress":"9e9958d9","chunk-2164cb4f":"86575fa5","chunk-6bcb967a":"6e9d93d1","chunk-6da92588":"e543fb46","chunk-6f25e092":"851ee6e0","chunk-72b462f4":"079bdd57","chunk-7482cb10":"b596472a","chunk-76fe6b7b":"555f1b81","chunk-77f2492e":"ef0d772c","chunk-8b163f4e":"3d129216","chunk-fbc33bd2":"7e2dd829","chunk-796b1987":"a284b6fe","chunk-79c87bbc":"88708d82","chunk-7ac6ada4":"d7c15e13","chunk-7b4fb2c9":"3376bc4f","chunk-622e807e":"9c6a2350","chunk-f2b43d54":"ea459f3c","chunk-7ba25635":"2b7340b2","chunk-7bbbb829":"ad2de31e","chunk-9600860a":"62ad6c9c","chunk-9c090f84":"1d4f8401","chunk-aca8c4e2":"eae84930","chunk-153a4bf6":"d37c4420","chunk-240c73bc":"9e269ac0","chunk-b3439622":"b4f44b1f","chunk-b3589054":"d6fec644","chunk-b664dd94":"dc5890ac","chunk-bac01d38":"0ba6ec40","chunk-be723f68":"400981b4","CollegeRealName":"818fcf5a","chunk-d0ae8ff8":"50a85c5b","chunk-f77f0c82":"77f3e9dd","chunk-2d0b1e31":"363b1a89","chunk-2d0b276b":"b0abeab9","chunk-e1fb4d38":"7ad8d639","chunk-ea7ef50e":"c44d4463","chunk-faae7204":"567b006f","chunk-fae895f2":"ca86b5b6","chunk-fd6d56bc":"3e9a7aff","chunk-ff955ee2":"55c17d34","chunk-1b8349cb":"b74a18d6"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"CourseLibraryEdit~CourseLibrarySection~CourseShop":1,"CourseShop":1,"CourseLibrary~CourseResources":1,"CourseLibrary":1,"CourseResources":1,"CourseResourcesEdit":1,"Dashboard":1,"EducationalAdd":1,"EducationalBatchAdd":1,"EducationalEdit":1,"MySalesRecord":1,"MySalesRecordAdd":1,"OfflineRecordReview":1,"ProductManage":1,"chunk-037f4b61":1,"chunk-04be5594":1,"chunk-07b406d3":1,"chunk-0b6a1d54":1,"chunk-166839b5":1,"chunk-1ac974be":1,"CourseLibrarySection":1,"chunk-1bb13728":1,"chunk-5d3ccfe1":1,"chunk-7e84dcd0":1,"chunk-1f75a0b4":1,"chunk-20062d88":1,"chunk-2087d242":1,"chunk-218d0c12":1,"chunk-22ce03a8":1,"chunk-2431d57f":1,"chunk-2592f322":1,"chunk-29cfdbb3":1,"chunk-2df5ae5a":1,"ProductManageAdd":1,"CourseLibraryAdd":1,"CourseLibraryEdit":1,"CourseResourcesAdd":1,"chunk-b714e690":1,"chunk-3eed9f9a":1,"chunk-4abe596c":1,"chunk-5376cd13":1,"chunk-59677937":1,"chunk-c9ae9d90":1,"chunk-2f9e4792":1,"chunk-314c2070":1,"chunk-34ff69a4":1,"chunk-365e9475":1,"chunk-36ff58fd":1,"chunk-37fb59a2":1,"chunk-3ccf676e":1,"chunk-3f74100c":1,"chunk-412d0cc6":1,"chunk-41fa7260":1,"chunk-424d0da2":1,"chunk-4a308614":1,"chunk-4bf58560":1,"chunk-563b9f0c":1,"chunk-58222bce":1,"chunk-5ad459ce":1,"chunk-5c6bb2fc":1,"chunk-5c788fd0":1,"chunk-63721bda":1,"chunk-63dead69":1,"chunk-63ead194":1,"chunk-6a411276":1,"CourseProgress":1,"chunk-2164cb4f":1,"chunk-6bcb967a":1,"chunk-6da92588":1,"chunk-6f25e092":1,"chunk-72b462f4":1,"chunk-7482cb10":1,"chunk-76fe6b7b":1,"chunk-77f2492e":1,"chunk-8b163f4e":1,"chunk-fbc33bd2":1,"chunk-796b1987":1,"chunk-79c87bbc":1,"chunk-7ac6ada4":1,"chunk-7b4fb2c9":1,"chunk-622e807e":1,"chunk-f2b43d54":1,"chunk-7ba25635":1,"chunk-7bbbb829":1,"chunk-9600860a":1,"chunk-9c090f84":1,"chunk-aca8c4e2":1,"chunk-153a4bf6":1,"chunk-240c73bc":1,"chunk-b3439622":1,"chunk-b3589054":1,"chunk-b664dd94":1,"chunk-bac01d38":1,"CollegeRealName":1,"chunk-d0ae8ff8":1,"chunk-f77f0c82":1,"chunk-e1fb4d38":1,"chunk-ea7ef50e":1,"chunk-faae7204":1,"chunk-fae895f2":1,"chunk-fd6d56bc":1,"chunk-ff955ee2":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"404":"404","CourseLibraryEdit~CourseLibrarySection~CourseShop":"CourseLibraryEdit~CourseLibrarySection~CourseShop","CourseShop":"CourseShop","CourseLibrary~CourseResources":"CourseLibrary~CourseResources","CourseLibrary":"CourseLibrary","CourseResources":"CourseResources","CourseResourcesEdit":"CourseResourcesEdit","Dashboard":"Dashboard","EducationalAdd":"EducationalAdd","EducationalBatchAdd":"EducationalBatchAdd","EducationalEdit":"EducationalEdit","MySalesRecord":"MySalesRecord","MySalesRecordAdd":"MySalesRecordAdd","OfflineRecordReview":"OfflineRecordReview","ProductManage":"ProductManage","Redirect":"Redirect","CourseLibrarySection":"CourseLibrarySection","ProductManageAdd":"ProductManageAdd","CourseLibraryAdd":"CourseLibraryAdd","CourseLibraryEdit":"CourseLibraryEdit","CourseResourcesAdd":"CourseResourcesAdd","CourseProgress":"CourseProgress","CollegeRealName":"CollegeRealName"}[chunkId]||chunkId) + "." + {"404":"31d6cfe0","CourseLibraryEdit~CourseLibrarySection~CourseShop":"25b33588","CourseShop":"ea6d5979","CourseLibrary~CourseResources":"25b33588","CourseLibrary":"2a733b54","CourseResources":"b0f91265","CourseResourcesEdit":"8c3a7281","Dashboard":"8a0e19df","EducationalAdd":"50217aff","EducationalBatchAdd":"9eafb67f","EducationalEdit":"2d38dade","MySalesRecord":"06c10e38","MySalesRecordAdd":"7cae8af5","OfflineRecordReview":"46707984","ProductManage":"25b33588","Redirect":"31d6cfe0","chunk-037f4b61":"e1809276","chunk-04be5594":"f9d97d18","chunk-07b406d3":"5400a587","chunk-0b6a1d54":"407ade11","chunk-166839b5":"a6be9a75","chunk-1ac974be":"081503fa","chunk-1f24ceb0":"31d6cfe0","CourseLibrarySection":"e3f11b3d","chunk-1bb13728":"ddecaa36","chunk-5d3ccfe1":"f8a64a15","chunk-7e84dcd0":"50fb5af9","chunk-1f75a0b4":"a510f63d","chunk-20062d88":"ec24db91","chunk-2087d242":"019c3a89","chunk-218d0c12":"e1809276","chunk-22ce03a8":"11a8057a","chunk-2431d57f":"74474ed5","chunk-2592f322":"c0a7ed0e","chunk-29cfdbb3":"339117c0","chunk-2df5ae5a":"d099b0cc","chunk-2e24c3ec":"31d6cfe0","ProductManageAdd":"4dd224cd","CourseLibraryAdd":"4f94d878","CourseLibraryEdit":"ad63c9b1","CourseResourcesAdd":"8c10bb9c","chunk-b714e690":"96ec7f17","chunk-3eed9f9a":"1d567157","chunk-4abe596c":"70f1541c","chunk-5376cd13":"7e37e020","chunk-59677937":"73d957fa","chunk-c9ae9d90":"96caab90","chunk-2f9e4792":"e1809276","chunk-314c2070":"6e79d674","chunk-34ff69a4":"45afe22f","chunk-365e9475":"08b1b4bf","chunk-36ff58fd":"88b9a1ed","chunk-37fb59a2":"353a1f51","chunk-3ccf676e":"a9455e84","chunk-3f74100c":"a636997b","chunk-412d0cc6":"e1809276","chunk-41fa7260":"a31953d4","chunk-424d0da2":"17f43438","chunk-4a308614":"dfdbad8f","chunk-4bf58560":"e1809276","chunk-563b9f0c":"54215b9a","chunk-58222bce":"e1809276","chunk-5ad459ce":"2fcc5fc3","chunk-5c6bb2fc":"5af34e05","chunk-5c788fd0":"add45e69","chunk-63721bda":"cc6067f4","chunk-63dead69":"e1809276","chunk-63ead194":"1d641197","chunk-6a411276":"e1809276","CourseProgress":"5fb1e892","chunk-2164cb4f":"c6e77feb","chunk-6bcb967a":"62fd749d","chunk-6da92588":"ffcfd86c","chunk-6f25e092":"203d0017","chunk-72b462f4":"738d51c4","chunk-7482cb10":"d98c7f0f","chunk-76fe6b7b":"fc28beb0","chunk-77f2492e":"120a7bb0","chunk-8b163f4e":"b6662e8d","chunk-fbc33bd2":"282bf702","chunk-796b1987":"e405ac21","chunk-79c87bbc":"140ea91f","chunk-7ac6ada4":"58ce649c","chunk-7b4fb2c9":"e1809276","chunk-622e807e":"edf87236","chunk-f2b43d54":"b18c664d","chunk-7ba25635":"998fd8eb","chunk-7bbbb829":"7db65085","chunk-9600860a":"e1809276","chunk-9c090f84":"e1809276","chunk-aca8c4e2":"6c2bb173","chunk-153a4bf6":"f4bd3c83","chunk-240c73bc":"fe1fd008","chunk-b3439622":"e1809276","chunk-b3589054":"6fe30866","chunk-b664dd94":"11f8a6c5","chunk-bac01d38":"e1809276","chunk-be723f68":"31d6cfe0","CollegeRealName":"68cc5a7a","chunk-d0ae8ff8":"d965b2b1","chunk-f77f0c82":"ae2143ca","chunk-2d0b1e31":"31d6cfe0","chunk-2d0b276b":"31d6cfe0","chunk-e1fb4d38":"a3c1d6cb","chunk-ea7ef50e":"6d711864","chunk-faae7204":"1de5487f","chunk-fae895f2":"9dcb797e","chunk-fd6d56bc":"52ad95b2","chunk-ff955ee2":"d0b30ead","chunk-1b8349cb":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
